<template>
    <div class="dealPwd">
        <Header title="交易密码" :show-back="true"/>
        <div class="wrapper">
            <van-field
                    class="cell"
                    v-model="password"
                    :label="hasDealPsd ? '新密码': '交易密码'"
                    label-class="cell-label"
                    type="password"
                    placeholder="请输入交易密码"/>
            <van-field
                    class="cell"
                    v-model="password1"
                    label="确认密码"
                    label-class="cell-label"
                    type="password"
                    placeholder="请再次输入交易密码"/>
            <van-field
                    class="cell"
                    v-model="verificationCode"
                    label="验证码"
                    label-class="cell-label"
                    placeholder="请输入验证码">
                <span class="code-btn" slot="button" id="getCodeBtn" @click="getCode">获取验证码</span>
            </van-field>
            <button class="form-item-btn" @click="submit">确认</button>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";
    import {mapMutations} from "vuex"

    export default {
        components: {
            Header
        },
        data() {
            return {
                hasDealPsd: false, //是否设置交易密码
                verificationCode: "",
                password: "",
                password1: "",
                codeFlag: false,
            };
        },
        methods: {
            // 获取验证码
            getCode() {
                if (this.codeFlag) {
                    return
                }
                this.codeFlag = true;
                let btn = document.getElementById("getCodeBtn");
                let num = 60;
                let t = setInterval(() => {
                    btn.innerHTML = `${num}秒`;
                    num--;
                    if (num <= 0) {
                        this.codeFlag = false;
                        btn.innerHTML = "获取验证码";
                        clearInterval(t);
                    }
                }, 1000);
                this.ajax.post("appapi/user/sendSmsCode", {}).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                    } else {
                        clearInterval(t);
                        this.codeFlag = false;
                        btn.innerHTML = "获取验证码";
                    }
                })
            },
            submit() {
                if (!this.password) {
                    this.$toast("请输入交易密码");
                    return;
                }
                if (!this.password1) {
                    this.$toast("请再次输入交易密码");
                    return;
                }
                if (this.password !== this.password1) {
                    this.$toast("两次输入的密码不一致");
                    return;
                }
                let parme = {
                    paypassword: this.password,
                    vertification: this.verificationCode,
                };
                this.ajax.post("appapi/user/addPayPassword", parme).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        this.setUserInfo({paypwd: 1});
                        this.$router.go(-1);
                    }
                })
            },
            ...mapMutations(["setUserInfo"])
        }
    };
</script>


<style lang="scss">
    .dealPwd {
        .wrapper {
            padding: 30px;
        }

        .form {
            height: 636px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 12px 34px 0px rgba(48, 77, 120, 0.1);
            border-radius: 20px;
        }

        .cell {
            padding: 60px 40px 25px;

            &-label {
                font-size: 30px;
                color: #333;
                font-weight: bold;
            }

            input {
                font-size: 24px;
                color: #c5c4c4;
            }

            .code-btn {
                font-size: 28px;
                cursor: pointer;
                font-weight: bold;
                color: rgba(31, 194, 109, 1);
                line-height: 20px;
            }
        }

        .form-item-btn {
            margin-top: 50px;
        }
    }
</style>
